import { Button, Grid, Stack, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useOptions from 'hooks/useOptions';
import useTherapists from 'hooks/useTherapists';
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link, useLocation, useNavigate } from 'react-router';
import JWTLogin from 'views/components/authentication/JWTLogin';
import Logo from 'views/components/Logo';
import AuthCardWrapper from 'views/layout/Wrappers/AuthCardWrapper';

const Login = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const matchDownMD = useMediaQuery(theme.breakpoints.down('md'));
  const { patientRegistrationEnabled, permissions } = useOptions();
  const [is2faRequired, setIs2faRequired] = useState(false);

  const location = useLocation();

  const login2fa = (location.state as any)?.login2fa;
  const email = (location.state as any)?.username;
  const password = (location.state as any)?.password;
  const therapists = useTherapists();
  // console.log('therapists are ', therapists.therapists);
  const checkComplimentarySession = (users) => {
    return (
      users && users.some((userObj) => userObj?.userOptions.accessComplimentarySession || userObj?.userOptions.manageComplimentarySession)
    );
  };

  const showComplimentarySessionButton = checkComplimentarySession(therapists.therapists);
  // console.log('Show complimentary session ', showComplimentarySessionButton);

  useEffect(() => {
    if (login2fa) setIs2faRequired(true);
  }, [login2fa]);
  //
  return (
    <AuthCardWrapper>
      <Grid
        container
        spacing={2}
        alignItems="flex-start"
        justifyContent="center"
        sx={{
          flexGrow: 1,
          padding: '12%',
          paddingX: '20%'
        }}
      >
        <Grid item sx={{ mb: 0 }}>
          <Button>
            <Logo size="lg" height={'15vh'} />
          </Button>
        </Grid>
        <Grid item xs={12}>
          <Grid
            container
            direction={matchDownMD ? 'column-reverse' : 'row'}
            alignItems={matchDownMD ? 'flex-start' : 'center'}
            justifyContent={matchDownMD ? 'center' : 'flex-start'}
          >
            <Grid item>
              <Stack alignItems="flex-start" justifyContent="center" spacing={1}>
                <Typography color="black" gutterBottom variant={matchDownMD ? 'h3' : 'h2'}>
                  <FormattedMessage defaultMessage="Welcome" />
                </Typography>
                <Typography variant="caption" fontSize="16px" textAlign="left">
                  {!is2faRequired ? (
                    <FormattedMessage defaultMessage="Enter your email to continue" />
                  ) : (
                    <FormattedMessage defaultMessage="Enter your code to continue" />
                  )}
                </Typography>
              </Stack>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <JWTLogin is2faRequired={is2faRequired} setIs2faRequired={setIs2faRequired} email={email} password={password} />
        </Grid>
        <Grid display="flex" justifyContent="space-between" item xs={12} sm={12}>
          <Grid item xs={12}>
            {patientRegistrationEnabled && (
              <Grid item container justifyContent="center" alignItems="flex-start" xs={12} gap={0.8}>
                <Typography variant="subtitle1" color="black">
                  <FormattedMessage defaultMessage="Don't have an account?" />
                </Typography>
                <Link to="/register">
                  <Typography variant="subtitle1" color="secondary" sx={{ textDecoration: 'underline' }}>
                    <FormattedMessage defaultMessage="Register" />
                  </Typography>
                </Link>
              </Grid>
            )}
          </Grid>
        </Grid>
        {showComplimentarySessionButton && (
          <Grid item xs={12} display="flex" justifyContent="center" alignItems="center">
            <Button onClick={() => navigate('/contactme')} variant="contained">
              <FormattedMessage defaultMessage="Request a Complimentary Session" />
            </Button>
          </Grid>
        )}
      </Grid>
    </AuthCardWrapper>
  );
};

export default Login;
